module.exports = __webpack_public_path__ + "assets/icons/calendar-clock-06b4.svg";